import { mergeRefs } from "@/src/lib/utils";
import { forwardRef, useRef, useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";

export interface TooltipOnEllipsisProps extends React.HTMLAttributes<HTMLSpanElement> {}
export const TooltipOnEllipsis = forwardRef<HTMLSpanElement, TooltipOnEllipsisProps>((props, _ref) => {
  const innerRef = useRef<HTMLSpanElement>(null);
  const ref = mergeRefs(innerRef, _ref);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <TooltipProvider>
      <Tooltip
        open={tooltipOpen}
        onOpenChange={(open) => {
          if (!open) {
            setTooltipOpen(false);
          }
          if (!innerRef.current) {
            return;
          }
          if (open && innerRef.current.offsetWidth < (innerRef.current.firstChild! as HTMLSpanElement).offsetWidth) {
            setTooltipOpen(true);
          }
        }}
      >
        <TooltipTrigger asChild>
          <span {...props} ref={ref}>
            <span>{props.children}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[70vw]">{props.children}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});
